import { Link } from "react-router-dom";

var Glyphicon = require("components/utility/icons/Glyphicon");

var CurrentUser = require("lib/account/CurrentUser");
var FeedbackFormatter = require("lib/interface/FeedbackFormatter");
var ArbitrarySubjects = require("lib/data/ArbitrarySubjects");

var Spinner = require("components/utility/Spinner");
var UserAvatar = require("components/avatars/UserAvatar");
var AdminAvatar = require("components/avatars/AdminAvatar");

var MyShelfRouting = require("lib/routing/MyShelfRouting");

require("notifications/social_notifications.scss");

class SocialNotificationContainer extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			popoverOpen: false, notifications: null,
			pendingNotificationCount: CurrentUser.get().pending_notification_count,
			doneLoading: false, page: null, loading: false
		};
	}

	toggleSocialData(e) {
		$wr.nope(e)
		if (this.state.popoverOpen) {
			this.setState({ popoverOpen: false });
			$(this.refs.scrollArea).off("scroll", this.onPopoverScroll);

		} else {
			this.setState({ popoverOpen: true }, function() {
				$(this.refs.scrollArea).on("scroll", this.onPopoverScroll);
			}.bind(this));

			if (this.state.notifications == null) {
				this.fetchNotifications();
			}
		}
	}

	goToItem(notification, e) {
		var viewData = notification.view_data;
		if (!viewData || !viewData.subject_type) {
			console.error("No view_data or view_data.subject_type")
			return;
		}

		if (ArbitrarySubjects.onReadingPage(viewData.subject_type)) {
			$wr.redirect(MyShelfRouting.getPath({
				activeView: MyShelfRouting.VIEWS.LOGS_VIEW
			}));

		} else {
			var collection = ArbitrarySubjects.asCollection(viewData.subject_type);

			$wr.redirect(MyShelfRouting.getPath({
				activeView: MyShelfRouting.VIEWS.SHELF_VIEW,
				detailsView: collection,
				textID: viewData.text_id
			}));

		}
		this.setState({ popoverOpen: false });
	}

	render() {
		if (this.state.popoverOpen) {
			if (this.state.loading) {
				var loadingIndicator = (
					<div><Spinner placeholder={ true } scale={ 1.5 } /></div>
				);
			}
			if (this.state.notifications != null) {
				var popoverContent = _.map(this.state.notifications, function(notification, i) {
					// if (newsItem.subject.avatar) {
					// 	var avatar = (<StudentAvatar maxWidth={ 50 } student={ { avatar: newsItem.subject.avatar } } />);
					// } else {
					// 	var avatar = (<AdminAvatar maxWidth={ 50 } admin={ {} } />);
					// }
					// var activityTitle = newsItem.subject.response.activity.format_summary.title;

					// if (CurrentUser.hasID(newsItem.subject.response.user_id)) {
					// 	var ownerLine = "your response";
					// } else {
					// 	var ownerLine = `${ newsItem.subject.owner_name }'s response`;
					// }

					// return (
					// 	<div key={ i } onClick={ this.goToItem.bind(this, newsItem) }
					// 		className="socialNotificationItem clearfix">
					// 		{ avatar }
					// 		<div className="itemSummary">
					// 			<strong>{ newsItem.subject.commenter_name } </strong>
					// 			commented on { ownerLine } for <em>{ activityTitle }</em>
					// 		</div>
					// 	</div>
					// );

					if (notification.view_data && notification.view_data.source_user) {
						var avatar = (
							<UserAvatar user={ notification.view_data.source_user } maxWidth={ 50 }  />
						);
					}

					return (
						<div key={ i } onClick={ this.goToItem.bind(this, notification) }
							className="socialNotificationItem clearfix">
							{ avatar }
							<div className="itemSummary">
								{ FeedbackFormatter.formatSimple(notification.body) }
							</div>
						</div>
					);

				}.bind(this));

				if (CurrentUser.isAdmin()) {
					var teacherClass = "teacherPopover";
					var emptyStatePrompt = "Notifications about conversations with your students will appear here."
				} else {
					teacherClass = "";
					var emptyStatePrompt = "Your teacher's comments on your work will show here."
				}
				if (this.state.notifications.length == 0) {
					var emptyNotifications = [];
					var owlImgSrc = require("owls/owl-outline.png");
					for (var i = 0; i < 2; i++) {
						emptyNotifications.push(
							<div className="emptyNotificationRow" key={ i }>
								<img src={ owlImgSrc } alt=""/>
								<div className="emptyNotificationLineContainer">
									<div className="emptyNotificationLine"></div>
									<div className="emptyNotificationLine"></div>
								</div>	
							</div>
						)
					};

					var emptyNotificationsContainer = (
						<div className="emptyStateContainer">
							<p className="emptyText">
								{ emptyStatePrompt }
							</p>
							{ emptyNotifications }
						</div>
					)
				}
			}

			var popover = (
				<div className={ "popover fade in bottom " + teacherClass }>
					<div className="arrow"></div>
					<div className="popover-content" ref="scrollArea">
						{ emptyNotificationsContainer }
						{ popoverContent }
						{ loadingIndicator }
					</div>
				</div>
			)
		}
		var className = "notificationContainer socialNotificationContainer";
		if (this.state.pendingNotificationCount > 0) {
			var notificationsBell = "notificationsBell";
			if (CurrentUser.isAdmin()) {
				var adminNotificationsBadge = "adminBadge";
			}
			var notificationsBadge = "notificationBadge ";
			var notificationsCount = this.state.pendingNotificationCount;
			className += " fullSocialNotificationContainer";
		} else {
			notificationsBadge = "";
		}

		return (
			<div ref="wrapper" className={ className } >
				<span className={ "glyphicon glyphicon-bell " + notificationsBell } onClick={ this.toggleSocialData }></span>
				<span className={ notificationsBadge + adminNotificationsBadge } onClick={ this.toggleSocialData }>
					{ notificationsCount }
				</span>
				<br /><span className="notifyLabel" onClick={ this.toggleSocialData }>News</span>
				{ popover }
			</div>
		)
	}

	onPopoverScroll() {
		if ($(this.refs.scrollArea).scrollTop() >= 130 &&
			!this.state.loading && !this.state.doneLoading) {

			this.fetchNotifications()
		}
	}

	componentDidMount() {
		$(window.document).on("click", this.onDocumentClick);
		this.updatePageTitle();
	}

	componentWillUnmount() {
		$(window.document).off("click", this.onDocumentClick);
		$(this.refs.scrollArea).off("scroll", this.onPopoverScroll);
	}
	componentDidUpdate() {
		this.updatePageTitle();
	}

	onDocumentClick(e) {
		var isChild = $(e.target).closest(this.refs.wrapper).length > 0;
		if (!isChild && this.state.popoverOpen) {
			this.setState({ popoverOpen: false });
		}
	}

	fetchNotifications() {
		if (this.state.doneLoading) { return; }

		var params = { view_all: true, embed: "view_data.source_user,student.avatar" }

		if (this.state.page) {
			params.page = this.state.page + 1;
		}

		this.setState({ loading: true });

		CurrentUser.api().getNotifications(params, $wr.apiHandler(function(response) {
			var doneLoading = response.notifications.length < response.per_page;
			var newNotifications = (this.state.notifications || []).concat(response.notifications);
			this.setState({ notifications: newNotifications, page: response.page, 
				doneLoading: doneLoading, loading: false, pendingNotificationCount: 0 });
		}.bind(this)));
	}

	updatePageTitle() {
		if (this.state.pendingNotificationCount > 0) {
			$('title').text("Whooo's Reading (" + this.state.pendingNotificationCount + ") | " + CurrentUser.get().display_name);
		} else {
			$('title').text("Whooo's Reading | "  + CurrentUser.get().display_name);
		}
	}
};

SocialNotificationContainer.propTypes = StrictPropTypes({
});

module.exports = SocialNotificationContainer;



// WEBPACK FOOTER //
// ./modules/components/notifications/SocialNotificationContainer.js